import { RegistrationSource } from '../registration/registration-source.enum';

export interface RegistriaRequestRegisteredItem {
  brand: string;
  product_sku: string | null;
  purchase_date: Date | string | null;
  serial_number: string | null;
  source: RegistrationSource;
}
